import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import { fetchIndividualStaff } from "../../../../Redux/Slices/mainSlice";
import { fetchCountryCode } from "../../../../Redux/Slices/countrySlice";
import { editStaff } from "../../../../Redux/Slices/mainSlice";

// Custom layout
import MainLayout from "../../../../Layouts/Main";
import Select from 'react-select'

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";

// utils
import { validateInput , COUNTRIES} from "Services/Utils/validateInput";

// Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import ErrorMessage from "Components/ErrorMessage";

//utils
import { notifySuccess } from "Services/Utils/toastNotification";

const EditStaff = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    username: "",
    mobile: "",
    email: "",
    employeeCode: "",
    countryCode: "",
  });

  const COUNTRY_CODES = Object.entries(COUNTRIES).map(([code, name]) => ({
      value: code,
    label: `${name} (${code})`
  })).sort((a, b) => a.label.localeCompare(b.label));

  // Store access checkboxes state
  const accessOptions = [
    { access_id: 1, access_name: "All" },
    { access_id: 2, access_name: "Dashboard" },
    { access_id: 3, access_name: "Request Management" },
    { access_id: 4, access_name: "Company Management" },
    { access_id: 5, access_name: "User Management" },
    { access_id: 6, access_name: "Content Management" },
    { access_id: 7, access_name: "Staff Management" },
    { access_id: 8, access_name: "Product Catalog" },
    { access_id: 9, access_name: "Contact Enquiries" },
    { access_id: 10, access_name: "Choose KG" },
    { access_id: 11, access_name: "KG Mining" },
  ];

  const [accessDetails, setAccessDetails] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
    11: false,
  });

  const phoneInputStyles = {
    container: {
      display: 'flex',
      // width: '33vw',
      border: '1px solid #B2BEC3',
      borderRadius: '4px',
      height: '7vh',
    },
    countryCodeSelect: {
      height: '7vh',
      width: '200px', 
      border: 'none',
      borderRight: '1px solid #B2BEC3',
      borderRadius: '4px 0 0 4px',
      backgroundColor: 'white',
      color: '#697077',
      fontSize: '2.2vh',
      padding: '0 10px',
      cursor: 'pointer',
    },
    numberInput: {
      width: '50%', 
      border: 'none',
      borderRadius: '0 4px 4px 0',
      padding: '0 2vh',
      color: "black",
      fontSize: '2.2vh',
      outline: 'none',
    }
  };

  const [initialAccessDetails, setInitialAccessDetails] = useState([]);

   // Fetch country data once when the app starts
        useEffect(() => {
          dispatch(fetchCountryCode());
        }, [dispatch]);
    
  useEffect(() => {
    dispatch(
      fetchIndividualStaff({
        data: {
          id: id,
        },
        callBack: fetchStaffCB,
      })
    );
  }, []);

  const fetchStaffCB = (value) => {
    let updatedAccessDetails = {};
    setFormData({
      username: value?.result?.firstname,
      mobile: value?.result?.mobile,
      email: value?.result?.email,
      countryCode: value?.result?.country_code, 
      employeeCode: value?.result?.employee_code,
    });
    setInitialAccessDetails(value?.result?.staff_access_details);
    value?.result?.staff_access_details.forEach((accessDetail) => {
      updatedAccessDetails[accessDetail.access_id] = true;
    });

    setAccessDetails((prev) => ({
      ...prev,
      ...updatedAccessDetails,
    }));
  };

  const handleCheckboxChange = (e, option) => {
    const { checked } = e.target;

    // Handle "All" checkbox logic
    if (option.access_name === "All") {
      const newAccessDetails = accessOptions.reduce((acc, curr) => {
        acc[curr.access_id] = checked;
        return acc;
      }, {});
      setAccessDetails(newAccessDetails);
    } else {
      // Handle individual checkbox logic
      setAccessDetails((prev) => ({
        ...prev,
        [option.access_id]: checked,
      }));
    }
  };

  useEffect(() => {
    const allSelected = accessOptions.slice(1).every(option => accessDetails[option.access_id]);
  
    if (accessDetails[1] !== allSelected) { // Avoid unnecessary state updates
      setAccessDetails(prev => ({
        ...prev,
        1: allSelected,
      }));
    }
  }, [accessDetails]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => {
      const { [name]: removedError, ...restErrors } = prevErrors;
      return restErrors;
    });
  };

  const handleValidation = () => {
    let validationErrors = {};
    
    // Handle mobile validation separately with country code
    const numberError = validateInput("mobile", formData.mobile, "", formData.countryCode);
    if (numberError.mobile) {
      validationErrors.mobile = numberError.mobile;
    }
  
    // Handle other fields
    Object.keys(formData).forEach((key) => {
      if (key !== 'mobile') { // Skip mobile as it's handled above
        const error = validateInput(key, formData[key]);
        if (Object.keys(error).length > 0) {
          validationErrors = { ...validationErrors, ...error };
        }
      }
    });
    setErrors(validationErrors);
    return validationErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length === 0) {
      console.log(initialAccessDetails);
      const accessDetailsToSubmit = accessOptions
        .map((option) => {
          const isSelected = accessDetails[option.access_id];
          const existingAccessDetail = initialAccessDetails.find(
            (access) => access.access_id === option.access_id
          );
          // console.log('ppp',existingAccessDetail)

          if (existingAccessDetail) {
            // If the access was already present in the initial details
            if (!existingAccessDetail.hasOwnProperty("isAdded") && isSelected) {
              // If the checkbox is still selected and `isAdded` is false, no changes
              return {
                staff_access_id: existingAccessDetail.staff_access_id,
                access_id: option.access_id,
                access_name: option.access_name,
                isDeleted: false,
                isAdded: false,
              };
            } else {
              // If the checkbox is deselected or the initial state had `isDeleted: false`
              return {
                staff_access_id: existingAccessDetail.staff_access_id,
                access_id: option.access_id,
                access_name: option.access_name,
                isDeleted: !isSelected, // Mark as deleted if not selected
                isAdded: isSelected,
              };
            }
          } else {
            // If the access is newly added
            if (isSelected) {
              return {
                access_id: option.access_id,
                access_name: option.access_name,
                isDeleted: false,
                isAdded: isSelected, // Add access if selected
              };
            }
            //if no change
            return null;
          }
        })
        .filter((detail) => detail !== null);

      const finalData = {
        user_id: id,
        firstname: formData.username,
        country_code: formData.countryCode || "",
        mobile: formData.mobile,
        email: formData.email,
        employee_code: formData.employeeCode,
        access_details: accessDetailsToSubmit,
      };
      // console.log(finalData);
      // Send 'finalData' to the backend
      dispatch(
        editStaff({
          data: finalData,
          callBack: editStaffCB,
        })
      );
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    setFormData(prev => ({
      ...prev,
      mobile: value
    }));

    setErrors(prevErrors => ({
      ...prevErrors,
      mobile: "",
    }));

  };

  const handleCountryCodeChange = (selectedOption) => {
    setFormData(prev => ({
      ...prev,
      countryCode: selectedOption ? selectedOption.value : ''
    }));

    setErrors(prevErrors => ({
      ...prevErrors,
      countryCode: "",
    }));
  };

  const editStaffCB = (value) => {
    notifySuccess("Staff Edited Successfully");
    navigate(-1);
    //to remove the states of check boxes
    // console.log(value);
  };

  return (
    <MainLayout pageName={"Staff Management"}>
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Staff List</p>
      </div>
      <form onSubmit={handleSubmit} className="addStaffContainer">
        {/* Header */}
        <div className="addStaffContainerHeader">
          <h2>Edit Staff Details</h2>
        </div>
        <hr style={{ backgroundColor: "#E6E6E6" }} />
        <div className="addStaffContainerInputBoxBody">
          <div className="addStaffInputContainer">
            <p>Name</p>
            <div className="addStaffInputBoxContainer">
              <InputBox
                inputStyle={{
                  padding: "1px 2vh 1px 2vh",
                  height: "7vh",
                  color: "black"
                }}
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
              <ErrorMessage message={errors.username} />
            </div>
          </div>

          <div className="addStaffInputContainer">
            <p>Mobile Number</p>
            <div className="addStaffInputBoxContainer">
            <div style={phoneInputStyles.container}>
            <Select 
              options={COUNTRY_CODES}
              value={COUNTRY_CODES.find(option => option.value === formData.countryCode)}
              onChange={handleCountryCodeChange}
              styles={{
                control: (provided) => ({
                  ...provided,
                  ...phoneInputStyles.countryCodeSelect,
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
            <input
              style={phoneInputStyles.numberInput}
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleMobileChange}
              placeholder="Enter phone number"
            />
          </div>
          {errors.mobile && <ErrorMessage message={errors.mobile} />}
        </div>
      </div>

          <div className="addStaffInputContainer">
            <p>Email ID</p>
            <div className="addStaffInputBoxContainer">
              <InputBox
                inputStyle={{
                  padding: "1px 2vh 1px 2vh",
                  height: "7vh",
                  color: "black"
                }}
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              <ErrorMessage message={errors.email} />
            </div>
          </div>
          <div className="addStaffInputContainer">
            <p>Employee Code</p>
            <div className="addStaffInputBoxContainer">
              <InputBox
                inputStyle={{
                  padding: "1px 2vh 1px 2vh",
                  height: "7vh",
                  color: "black"
                }}
                name="employeeCode"
                value={formData.employeeCode}
                onChange={handleChange}
              />
              <ErrorMessage message={errors.employeeCode} />
            </div>
          </div>
        </div>
        <div className="addStaffCheckBoxFieldsContainer">
          <p className="addStaffCheckBoxFieldsHeader">Access</p>
          <div className="addStaffCheckBoxes">
            {accessOptions.map((option) => (
              <div
                className="addStaffCheckBoxFieldContainer"
                key={option.access_id}
              >
                <div className="addStaffCheckBoxContainer">
                  <InputBox
                    type="checkBox"
                    inputStyle={{
                      boxShadow: "none",
                    }}
                    onChange={(e) => handleCheckboxChange(e, option)}
                    checked={accessDetails[option.access_id] || false}
                    // checked={accessDetails[option.access_id]}
                  />
                </div>
                <p>{option.access_name}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="addStaffButtons">
          <div className="addStaffButtonContainer">
            <Button
              buttonStyle={{ height: "2vh", backgroundColor: "#FFFFFF" }}
              titleStlye={{ color: "#888888" }}
              title="Cancel"
              onClick={() => navigate(-1)}
            />
          </div>
          <div className="addStaffButtonContainer">
            <Button
              forForm={true}
              buttonStyle={{ height: "2vh" }}
              title="Save"
            />
          </div>
        </div>
      </form>
    </MainLayout>
  );
};

export default EditStaff;
